import React, {useEffect, useState} from 'react';
import './App.css';
import {TokenField} from "react-tokenfield";
import SyntaxHighlighter from 'react-syntax-highlighter';
import {docco} from 'react-syntax-highlighter/dist/esm/styles/hljs';

interface User {
    firstName: string
    lastName: string
    email: string
    image: string
}

function Demo4() {
    const [tokens] = useState<string[]>([
        "shahar.levi@me.com",
        "john.smith@google.com",
        "invalid-email"
    ]);

    const emailPattern: string =
        "[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$";

    const [users, setUsers] = useState<User[]>([])
    useEffect(() => {
        window
            .fetch('https://dummyjson.com/users')
            .then((res: Response) => res.json())
            .then((res) => setUsers(res.users))
    }, [])

    function renderOptions(str: string): React.ReactElement {
        return (
            <div
                style={{
                    maxWidth: '300px',
                    maxHeight: '300px',
                    overflow: 'auto',
                    scrollBehavior: 'smooth',
                    boxShadow: '1px 1px 5px #aaa',
                    borderRadius: '3px',
                    background: '#fff'
                }}
            >
                {users
                    .filter(
                        (user) =>
                            user.email.toLowerCase().startsWith(str.toLowerCase()) ||
                            user.firstName.toLowerCase().startsWith(str.toLowerCase()) ||
                            user.lastName.toLowerCase().startsWith(str.toLowerCase())
                    )
                    .map((user) => (
                        <div
                            key={user.email}
                            style={{display: 'flex', alignItems: 'center', padding: '10px'}}
                            data-value={user.email}
                        >
                            <img
                                alt={user.email}
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    marginRight: '10px',
                                    padding: '5px',
                                    borderRadius: '24px',
                                    border: '1px solid #aaa',
                                    background: '#fafafa'
                                }}
                                src={user.image}
                            />
                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                <div>
                                    <b>{`${user.firstName} ${user.lastName}`}</b>
                                </div>
                                <div style={{fontWeight: 100}}>{user.email}</div>
                            </div>
                        </div>
                    ))}
            </div>)
    }

    return (

        <div className='Box'>
            <h1>Auto Complete TokenField</h1>
            <h3>Demo</h3>
            <TokenField
                options={{render: (str) => renderOptions(str), selectedClassName: 'selected'}}
                placeholder={'Type an email address'}
                autoFocus={false}
                showRemoveButton={false}
                pattern={emailPattern}
                delimiters={' ;,'}
                tokens={tokens}
            />
            <h3>Code Sample</h3>
            <SyntaxHighlighter language="javascript" style={docco}>
                {
`import React, {useEffect, useState} from 'react';
import './App.css';
import {TokenField} from "react-tokenfield";

interface User {
    firstName: string
    lastName: string
    email: string
    image: string
}

function Demo() {
    const [tokens] = useState<string[]>([]);

const emailPattern: string =
             "[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\\\.[a-zA-Z]{2,}$";
const [users, setUsers] = useState<User[]>([])

useEffect(() => {
    window
        .fetch('https://dummyjson.com/users')
        .then((res: Response) => res.json())
        .then((res) => setUsers(res.users))
}, [])

function renderOptions(str: string): React.ReactElement {
    return (
        <div
            style={{
                maxWidth: '300px',
                maxHeight: '300px',
                overflow: 'auto',
                scrollBehavior: 'smooth',
                boxShadow: '1px 1px 5px #aaa',
                borderRadius: '3px',
                background: '#fff'
            }}
        >
            {users
                .filter(
                    (user) =>
                        user.email.toLowerCase().startsWith(str.toLowerCase()) ||
                        user.firstName.toLowerCase().startsWith(str.toLowerCase()) ||
                        user.lastName.toLowerCase().startsWith(str.toLowerCase())
                )
                .map((user) => (
                    <div
                        key={user.email}
                        style={{display: 'flex', alignItems: 'center', padding: '10px'}}
                        data-value={user.email}
                    >
                        <img
                            alt={user.email}
                            style={{
                                width: '24px',
                                height: '24px',
                                marginRight: '10px',
                                padding: '5px',
                                borderRadius: '24px',
                                border: '1px solid #aaa',
                                background: '#fafafa'
                            }}
                            src={user.image}
                        />
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            <div>
                                <b>{user.firstName + ' ' +user.lastName}</b>
                            </div>
                            <div style={{fontWeight: 100}}>{user.email}</div>
                        </div>
                    </div>
                ))}
        </div>)
}


return (
 <TokenField
    options={{renderCustom: (str) => renderOptions(str), selectedClassName: 'selected'}}
    placeholder={'Type an email address'}
    autoFocus={false}
    showRemoveButton={false}
    pattern={emailPattern}
    delimiters={' ;,'}
    tokens={tokens}/>
);
}

export default App;`
                }
            </SyntaxHighlighter>
        </div>

    );
}

export default Demo4;
